module.exports = __webpack_public_path__ + "static/media/10.b58cc701.png";